const createCsv = (data) => {
  const header = Object.keys(data[0]).join(',');
  const rows = data.map((obj) => Object.values(obj).join(','));
  return `${header}\n${rows.join('\n')}`;
};

export default createCsv;
